<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	<div class="mb-2 d-flex align-items-center">
			<el-form inline ref="form" :model="searchform">

				


					<el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0" >
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>
					
						<el-button type="primary" size="mini"  @click="layClick4">{{$t('newMsg.상담')}}</el-button>

					</el-form-item>
			</el-form>
		
			
    		
		</div>
	

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
       :row-class-name="tableRowClassName"
      border class="mt-2" @selection-change="handleSelectionChange"   :empty-text="$t('tableText.데이타가없습니다')">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*20-scope.$index}}</template>
        </el-table-column>


        

         
   

       <el-table-column
         :label="$t('msg.알본')"
         prop="admin_id" v-if="this.userid=='admin'" align="center" >
      </el-table-column>

     
      <el-table-column
        :label="$t('msg.문의제목')"
         prop="user_title" align="center">
        <template slot-scope="scope"><span @click="openModel(scope.row.id)" class="text-primary" style="cursor:pointer">{{scope.row.user_title}}</span><i class="ml-2 text-primary" :class="scope.row.mobile==='0' ? '':'el-icon-mobile'"></i></template>
      </el-table-column>


      <el-table-column
			prop="user_contents"
			align="center"
			:label="$t('msg.문의내용')"  
			>
			 <template slot-scope="scope" >
            	<el-input
					  type="textarea"
					  :rows="1"
					  v-model="scope.row.user_contents"  @click.native="openModel(scope.row.id)">
					</el-input>
        	</template>
		  </el-table-column>
		    

		   <el-table-column
        :label="$t('msg.문의시간')" 
        prop="add_time" align="center" >
      </el-table-column>

      <el-table-column
         :label="$t('msg.답변제목')"
        align="center">
        <template slot-scope="scope"><el-button type="text" @click="openModel(scope.row.id)">답변 보기</el-button></template>
      </el-table-column>
      <el-table-column
			align="center"
			 :label="$t('msg.답변내용')"
			>
			 <template slot-scope="scope"><el-button type="text" @click="openModel(scope.row.id)">비밀번호 입력 후 보기</el-button></template>
		  </el-table-column>


       <el-table-column
        :label="$t('tableText.처리시간')"
        prop="re_time" align="center" >
      </el-table-column>

		   <el-table-column
		   align="center"
			prop="status"
			:label="$t('tableText.처리상태')"
		 >
			<template slot-scope="scope">
            	<el-button type="text" @click="openModel(scope.row.id)"><span :class="colorObj[scope.row.status]">{{valObj[scope.row.status]}}</span></el-button>
        	</template>
		  </el-table-column>

		
		
		  
	
		 
    </el-table>
     <div style="height: 10px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0  bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
			
		  <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>	
         <el-dialog 
          :visible.sync="layModel4"
          :close-on-click-modal ="false"
          :width="layoutWidth" :title="$t('newMsg.신규상담작성')">
         
                  
          <el-form ref="layform3" :model="layform3" label-width="80px" v-loading="loading" :rules="rules"  class="form_application">

          	
          	  
					
             <div class="propreinfor" style="  border-top: 1px solid rgb(192, 196, 204);">

             	

            <el-form-item :label="$t('msg.제목')" class="mb-0" prop="addsubject">
            	<div class="contant">
                <el-select v-model="layform3.addsubject" :placeholder="$t('newMsg.분류선택')" size="mini" style="width:120px;margin-bottom:0px">
               <el-option
                      v-for="item in searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </div>
            </el-form-item>
          </div>
           <div class="propreinfor">
             <el-form-item :label="$t('msg.내용')" class="mb-0" prop="addcontent">
             	<div class="contant">
              <el-input v-model="layform3.addcontent" :rows="12" type="textarea"></el-input>
              </div>
                          </el-form-item>
							</div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit1">{{$t('newMsg.등록하기')}}</el-button>
          </span>
        </el-dialog>			

        <el-dialog
          title="환전비번 확인"
          :visible.sync="passwordDialogVisible"
          :close-on-click-modal="false"
          width="420px"
          @closed="resetPasswordDialog">
          <div>관리자 답변을 확인하려면 환전 비밀번호를 입력해 주세요.</div>
          <el-input
            v-model="qaPassword"
            type="text"
            class="mt-3"
            name="qa_exchange_password_check"
            autocomplete="off"
            :style="{'-webkit-text-security':qaPasswordVisible ? 'none' : 'disc'}"
            @keyup.enter.native="verifyQaPassword">
            <i
              slot="suffix"
              class="el-icon-view qa-password-eye"
              :class="{'is-visible':qaPasswordVisible}"
              :title="qaPasswordVisible ? '비밀번호 숨기기' : '비밀번호 보기'"
              @click="qaPasswordVisible=!qaPasswordVisible">
            </i>
          </el-input>
          <div v-if="passwordError" class="mt-2" style="color:#F56C6C;font-size:13px;">{{passwordError}}</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="passwordDialogVisible=false">취소</el-button>
            <el-button type="primary" :loading="passwordChecking" @click="verifyQaPassword">확인</el-button>
          </span>
        </el-dialog>
				
</div>
 </template>

 <script>
 import autoDialog from '../../components/common/auto-dialog.vue';
 	import qaDialog from '../../components/common/qa-dialog.vue';
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
       components: {
      layer,layerNew,qaDialog,autoDialog
    },
    	data(){
    		return{
    			 layoutWidth:'650px',
    			layModel4:false,
				passwordDialogVisible:false,
				passwordChecking:false,
				passwordError:'',
				qaPassword:'',
				qaPasswordVisible:false,
				selectedQaId:null,
    			dg:'0',
    			layform3:{
    				addsubject:'',
    				addcontent:''
    			},
    				searchOptions:[
                
    				{
		        	label:this.$i18n.t("newMsg.계좌문의"),
		        	value:'계좌문의'
		        },
		        {
		        	label:this.$i18n.t("newMsg.출금계좌등록문의"),
		        	value:'출금계좌등록문의'
		        },{
		        	label:this.$i18n.t("newMsg.충전지연"),
		        	value:'충전지연'
		        },{
		        	label:this.$i18n.t("newMsg.환전지연"),
		        	value:'환전지연'
		        },{
		        	label:this.$i18n.t("newMsg.버그신고"),
		        	value:'버그신고'
		        },{
		        	label:this.$i18n.t("nav.이벤트"),
		        	value:'이벤트'
		        },{
		        	label:this.$i18n.t("newMsg.기타문의"),
		        	value:'기타문의'
		        },
		       

		        ],
		        value:'',
    			dwidth:'900px',
    			shareShow:false,
    			otp:'',
    			 level_title:{
             '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")              
            },
    			domain:window.sessionStorage.getItem('domain'),
    			 sitetype:window.sessionStorage.getItem('sitetype'),
    			 bg:window.sessionStorage.getItem('bg'),
    			 userid:window.sessionStorage.getItem('userid'),
    			 aid:window.sessionStorage.getItem('admin_id'),
    			formLoading:false,
         		 idDialogVisible: false,
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    			  valObj:{
			       '0':this.$i18n.t("msg.대기"),
			        '1':this.$i18n.t("msg.완료"),
			        '2':this.$i18n.t("msg.보류"),
			       
			       
			      },
    			searchform:{
    				keyword:'',
    				time:[],
    			
		        searchOptions2:[
                
    					{
		        	label:this.$i18n.t("msg.전체"),
		        	value:''
		        },{
		        	label:this.$i18n.t("msg.대기"),
		        	value:'0'
		        },
		        
		        {
		        	label:this.$i18n.t("msg.보류"),
		        	value:'2'
		        },
		        {
		        	label:this.$i18n.t("msg.완료"),
		        	value:'1'
		        },
		      
		        ],
		   
		        value2:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    changeSwith(val){
    			console.log('val',val)
    			this.dg=val
this.currentPage=1;
          this.getList();

    			
    		},
    			
		        
    		
    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			          superSearch:false,
			          form:{
			          	id:'',
			          	user_title:'',
			          	user_id:'',
			          	user_contents:'',
			          	add_time:'',
			          	admin_contents:'',
			          	admin_title:'',
			          	mem_name:'',
			          	re_time:'',
			          	status:''
					
						
			          },
			           rules: {
				          username: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				           
				          ],
				           phone: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				          
				          ],
				            address: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				           
				          ],
				          
				           total_price: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				          
				          ],
				           addsubject:[{ required: true, message: '', trigger: 'blur'}],
                  			addcontent:[{ required: true, message: '', trigger: 'blur'}],

      }
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
    		   // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         cancelEvent(){
          this.shareShow = false
        },
         layClick4(){
    			this.layModel4 = true
    		
    		},
    		openIdModel(id,e){

    			this.shareShow = true
                let pix=window.screen.width;
           
                let width='1200px';
                if(pix<1200)
                {
                  width='95%';
                }

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    model:this.shareShow,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: [width+'', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;

    		},
    			submit1(){
    				
    			 let token=window.sessionStorage.getItem('user');
    			 this.$refs.layform3.validate((e)=>{
             if(!e) return;
              this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/inquiries_add',
                    data:
                    {
                    	title:this.layform3.addsubject,
                    	contents:this.layform3.addcontent,
                    	value:this.value
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                      
						this.getList();
                   
                       this.layModel4 = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
           })
          
    		},
    		 autoqaList(){
           this.$layer.iframe({
            type: 2,
            title: this.$i18n.t('newAdd.문의매크로관리'),
            content: {
                content: autoDialog,
                parent: this,
                data:{
                
               
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['800px', '550px'],
        });
        
        },
    			 // 搜索事件
			searchEvent(){

				this.currentPage=1;

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			       tableRowClassName({row, rowIndex}) {
						     
						       if (rowIndex%2 === 1) {
						        return 'odd-row-class';
						       }
						       else{
						         return 'edd-row-class';
						       }
						    },
			     
    		getList(){

    		

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/user/qalist?status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&dg='+this.dg;
    			
    			// if(bm!='')
    			// {
       //            urls=urls+'&search=service_no%3A'+bm+'%3Bphone%3A'+bm+'%3Btoken%3A'+bm+'%3Bmac%3A'+bm;
    			// }
             
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	
                 this.$message.error(error);
              this.loading = false
               
            })
    		},
		openModel(id){
			this.selectedQaId = id
			this.qaPassword = ''
			this.passwordError = ''
			this.passwordDialogVisible = true
		},
		verifyQaPassword(){
			if(!this.qaPassword){
				this.passwordError = '환전비밀번호를 입력해 주세요.'
				return
			}
			this.passwordChecking = true
			this.passwordError = ''
			let token=window.sessionStorage.getItem('user');
			this.$axios({
				method:'post',
				url:this.domain+'/user/qa',
				data:{id:this.selectedQaId, password:this.qaPassword},
				'Accept': 'application/json',
				headers: { 'Authorization': 'Bearer ' + token }
			}).then((response) => {
				if(response.data.code!==200){
					this.passwordError = response.data.msg || '환전비밀번호가 일치하지 않습니다.'
					return
				}
				this.passwordDialogVisible = false
				this.$layer.iframe({
		            type: 2,
		            title: '문의내용',
		            content: {
		                content: qaDialog,
		                parent: this,
		                data:{
		                info:{id:this.selectedQaId, qaData:response.data.data, autoQa:response.data.auto_qa},
		                layerid:'id'
		                }
		              
		            },
		            shadeClose: false,
		             maxmin : true,

		            shade: false,
		            area: ['650px', '550px'],
		           
		        });
			}).catch(() => {
				this.passwordError = '요청에 실패했습니다.'
			}).then(() => {
				this.passwordChecking = false
			})
		},
		resetPasswordDialog(){
			this.qaPassword = ''
			this.qaPasswordVisible = false
			this.passwordError = ''
			this.passwordChecking = false
		},
    		
    		
    		handleSelectionChange(val) {
    			//console.log(val)
                this.multipleSelection = val;

      },
    	  // 批量删除
			deleteAll(){
				this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
					confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					//console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	//console.log('id',item.idx);
					 	newids.push(item.id);
					 });

					 console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/user/qa_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }

.form_application{
  margin-bottom:5px;
}
.form_application .propreinfor {
         border-left: 1px solid rgb(192, 196, 204);
      
        margin: 0 auto;
        position:relative;


}
.form_application .contant {
       width:100%;
        padding:5px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        height: 100% !important;

}
>>>.el-form-item__label {
        
       position:absolute;
       margin:0px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        padding: 10px;
        background: #f9f9f9;
        font-weight: 400;
        color: #000;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: left;
          height: 100% !important;

      }
>>>.bluecolor .el-input__inner,>>>.bluecolor .el-textarea__inner{
        color:#333 !important;font-weight:bold
      }

.qa-password-eye{
  width:30px;
  height:30px;
  margin-top:5px;
  border-radius:50%;
  background:#f0f2f5;
  color:#606266;
  font-size:20px;
  line-height:30px;
  text-align:center;
  cursor:pointer;
}
.qa-password-eye:hover,
.qa-password-eye.is-visible{
  background:#ecf5ff;
  color:#409EFF;
}

</style>



// WEBPACK FOOTER //
// src/views/qa/list.vue